import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { Playbook, PlaybookRequest } from "../types/playbooks.types";

import { savePlaybookToCaches } from "./playbooksCacheUtils";

export const useCreatePlaybookMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<Playbook, Error, PlaybookRequest>({
        mutationFn: (payload) => salesApiService.playbooks.createPlaybook(payload),
        onSuccess: (playbook) => {
            savePlaybookToCaches(queryClient, playbook);
        },
    });
};
